module.exports = __webpack_public_path__ + "static/media/ic_emptyCheck_white.5cba4aaf.svg";